import { createAsyncThunk } from '@reduxjs/toolkit';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../provider/providerManager';
import { setRemoveSoc } from './AddonsAndUpgradesBlockSlice';


export const getUserUpgradesAsync = createAsyncThunk('addonsAndUpgradesBlock/getUserUpgradesAsync', async (data, thunkAPI) => {
    try {
        const state = thunkAPI.getState().addonsAndUpgradesBlock;
        const selfcarePage = thunkAPI.getState().selfcarePage;
        const subscriberNumber = selfcarePage?.selectedSubscriber?.productSubscriberNo ?? selfcarePage?.selectedSubscriber?.subscriberNumber;
        const worldType = state.worldType;
        const ban = selfcarePage?.selectedSubscriber?.ban;

        const params = {
            saleType: worldType,
            personalInfo: {
                otpPhone: subscriberNumber,
                ban: ban
            },
            saleTypeProduct: selfcarePage?.selectedSubscriber?.productType,
            removedSocList: state.removedSocList
        };

        const res = await ProviderManager.getProviderData('userUpgrade', params);
        res.Body.worldType = worldType;
        return res.Body;

    } catch (error) {

    } finally { }
});


export const removeServiceAsync = createAsyncThunk('addonsAndUpgradesBlock/removeServiceAsync', async (data, thunkAPI) => {
    try {
        thunkAPI.dispatch(showAppLoader());

        const state = thunkAPI.getState().addonsAndUpgradesBlock;
        const selfcarePage = thunkAPI.getState().selfcarePage;

        const worldType = state.worldType;
        const ban = selfcarePage?.selectedSubscriber?.ban;
        const count = state.userAddons.filter((item) => item.name == data.name).length;

        const params = {
            saleType: worldType,
            productList: [{ name: data.name, count: (count - 1) }],
            personalInfo: {
                otpPhone: selfcarePage?.selectedSubscriber?.productSubscriberNo,
                ban: ban
            },
            saleTypeProduct: selfcarePage?.selectedSubscriber?.productType
        };

        const res = await ProviderManager.getProviderData('removeService', params);
        const isSuccess = res?.Body?.isSuccess;

        if (isSuccess && worldType == 'internet') {
            await new Promise(resolve => setTimeout(resolve, 5000));
            thunkAPI.dispatch(setRemoveSoc(data.socSeqNo));
        }

        return res.Body;

    } catch (error) {

    } finally {
        thunkAPI.dispatch(hideAppLoader());
    }
});



